import { render, staticRenderFns } from "./WaterSolution.vue?vue&type=template&id=48a3a4e1&scoped=true&"
import script from "./WaterSolution.vue?vue&type=script&lang=js&"
export * from "./WaterSolution.vue?vue&type=script&lang=js&"
import style0 from "./WaterSolution.vue?vue&type=style&index=0&id=48a3a4e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3a4e1",
  null
  
)

export default component.exports